import ApiCollection          from '@widesk-core/models/ApiCollection';
import { Box }                from '@chakra-ui/react';
import CodePropertyValueModel from '@/models/services/code/CodePropertyValueModel';
import { Text }               from '@chakra-ui/react';
import dayjs                  from 'dayjs';
import { useTranslation }     from 'react-i18next';
import LocalizedFormat        from 'dayjs/plugin/localizedFormat';

dayjs.extend(LocalizedFormat);

interface ICodePropertiesProps {
	codePropertyValueCollection: ApiCollection<CodePropertyValueModel>;
}

const CodeProperties = (props: ICodePropertiesProps) => {

	const { codePropertyValueCollection } = props;
	
	const { t } = useTranslation();		
	
	if (codePropertyValueCollection.length > 0) {
		return (
			<Box
				display="flex"
				flexDirection="column"
				gap="20px"
				width="40%"
			>
				{
					codePropertyValueCollection.filter(codePropertyValue => (codePropertyValue.codeProperty.reference !== 'owner_email' && codePropertyValue.codeProperty.reference !== 'email')) .map(codePropertyValue => {
						const label = t(`pages.ticket.codeProperties.${codePropertyValue.codeProperty.reference}`) || codePropertyValue.codeProperty.reference;
						return (
							<Box 
								key={codePropertyValue.urn}
								display="flex"
								flexDirection="column"
								gap="2px"
							>
								<Text className='poppins-semibold' >{label}</Text>
								<PropertyValue codePropertyValue={codePropertyValue} />
							</Box>
						);
					})
				}
			</Box>
		);
	};

	return <></>;
}

const PropertyValue = ({ codePropertyValue }: {
	codePropertyValue: CodePropertyValueModel;
}) => {

	const { reference } = codePropertyValue.codeProperty;
	const isDate = reference === 'owner_birthdate';

	if (isDate) {
		return <Box>{dayjs(codePropertyValue.value).format('L')}</Box>;
	}

	return <Box>{codePropertyValue.value || ''}</Box>;
}

export default CodeProperties;